import React, { useCallback } from 'react';
import { BuildingIcon } from '@rsos/assets/icons';
import HoveredButton from '@rsos/components/capstone/HoveredButton';
import { getGeocommVLSApiKey } from '@rsos/utils/metaTags';
import { trackClickEstimatedFloorLevel } from '../helpers/trackings';
import { paramParser } from '../helpers/utils';
import { LeftText, RowBox, IconWrapper } from '../styles/common.styles';

const EstimatedFloorLevel = ({
  altitude,
  isHoverable,
  latitude,
  longitude,
  payloadID,
  requestID,
  irpVersion,
  portalType,
  uncertaintyRadius,
  altitudeUncertaintyRadius,
  isVerticalLocContentChecked,
}) => {
  const onClick = useCallback(() => {
    /**
     * @param {Number} lat - latitude
     * @param {Number} long - longitude
     * @param {String} token - token from GeoComm
     * @param {Number} hae - Height Above Ellipsoid in meters.
     * @param {Number} ortho - orthometric, verticle distance from sea level. - altitude
     * @param {Number} hacr - Horizontal Accuracy, default is 25. - uncertaintyRadius
     * @param {Number} vacr - Vertical Accuracy, default is 6. - altitudeUncertaintyRadius
     * @param {Boolean} suppl_data - Vertical Location in Andromeda
     * @param {Boolean} suppl_geocode - supplemental geocode - set to false for RSOS calls
     * @param {Boolean} '3dlink' - set to false for RSOS calls, unless Vertical Location in Andromeda is turned on
     * @param {Boolean} imlink - set to false for RSOS calls
     * @param {String} webscene_id - optional, currently undefined
     */

    const params = {
      lat: latitude,
      long: longitude,
      token: getGeocommVLSApiKey(),
      hae: altitude, // update from mw-5.2.0, altitude from our Google location is hae not ortho
      ortho: undefined,
      hacr: uncertaintyRadius || 25,
      vacr: altitudeUncertaintyRadius || 6,
      suppl_data: isVerticalLocContentChecked,
      suppl_geocode: isVerticalLocContentChecked,
      '3dlink': isVerticalLocContentChecked,
      imlink: false,
      webscene_id: undefined,
    };
    const paramsStr = paramParser(params);
    const geocommEstimatedFloorLevelUrl = `https://vls.geocomm.cloud/translate?${paramsStr}`;
    window.open(geocommEstimatedFloorLevelUrl, '_blank', 'noopener noreferrer');
    trackClickEstimatedFloorLevel(irpVersion, payloadID, requestID, portalType);
  }, [
    altitude,
    latitude,
    longitude,
    uncertaintyRadius,
    altitudeUncertaintyRadius,
    isVerticalLocContentChecked,
    irpVersion,
    requestID,
    payloadID,
    portalType,
  ]);
  return (
    <RowBox br="5px" isHoverable={isHoverable}>
      <RowBox>
        <IconWrapper>
          <BuildingIcon
            width={14}
            height={25}
            viewboxWidth={18}
            viewboxHeight={16}
          />
        </IconWrapper>
        <RowBox data-name="estimated-floor-level">
          <LeftText>Estimated Floor Level</LeftText>
        </RowBox>
      </RowBox>
      {isHoverable && (
        <HoveredButton onClick={onClick} withIcon hasExternalLink />
      )}
    </RowBox>
  );
};

export default EstimatedFloorLevel;
